import Vue from 'vue'

export default {

    /**
     * Set tasks
     * @param state
     * @param messages
     * @constructor
     */
    SET_MESSAGES(state, messages) {

        // Create tasks if absent
        if (!state.messages) state.messages = {};

        // Tasks can be a single task or tasks list
        if (!Array.isArray(messages)) messages = [messages];

        // Save each task from list to state
        messages.forEach(i => {

            // Remove deleted
            if(i.deleted_at)
            {
                Vue.delete(state.messages, i.id);
            } else

            // Skip non objects
            if (i) {
                // Store task
                Vue.set(state.messages, i.id, i);
            }
        });
    },

    /**
     * Set tasks
     * @param state
     * @param attachments
     * @constructor
     */
    SET_ATTACHMENTS(state, attachments) {

        // Create tasks if absent
        if (!state.attachments) state.attachments = {};

        // Tasks can be a single task or tasks list
        if (!Array.isArray(attachments)) attachments = [attachments];

        // Save each task from list to state
        attachments.forEach(i => {

            // Remove deleted
            if(i.deleted_at)
            {
                Vue.delete(state.attachments, i.id);
            } else

            // Skip non objects
            if (i) {
                // Store task
                Vue.set(state.attachments, i.id, i);
            }
        });
    },

   /**
     * Set discussions
     * @param state
     * @param discussions
     * @constructor
     */
    SET_DISCUSSIONS(state, discussions) {

        // Create discussions if absent
        if (!state.discussions) state.discussions = {};

        // discussions can be a single discussion or discussions list
        if (!Array.isArray(discussions)) discussions = [discussions];

        // Save each discussion from list to state
        discussions.forEach(i => {

            // Remove deleted
            if(i.deleted_at)
            {
                Vue.delete(state.discussions, i.id);
            } else

            // Skip non objects
            if (i) {
                // Store discussion
                Vue.set(state.discussions, i.id, i);
            }
        });
    },

}
